"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Scale_meta_1 = require("../Scale.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', Scale_meta_1.SCALE_CATEGORY_KEY, Scale_meta_1.SCALE_COMPONENT_KEY, ['placeholder']);